import Types from "./types";
import { CarService } from "../../../service/car-service";

const fetchDataSuccess = data => ({
    type: Types.FETCH_LEAD_BRAND_SUCCESS,
    data
});

const updateLeadBrand = data => ({
    type: Types.UPDATE_LEAD_BRAND,
    data
});

const setIsLoading = flag => ({
    type: Types.SET_IS_LOADING,
    isLoading: flag
});

const fetchDataFailure = error => ({
    type: Types.FETCH_LEAD_BRAND_FAILURE,
    error
});

const fetchData = () => dispatch => {
    dispatch(setIsLoading(true));
    CarService.fetchBrands()
        .then(response => {
            dispatch(fetchDataSuccess(response));
        })
        .catch(error => {
            dispatch(fetchDataFailure(error));
        });
};

export {
    fetchData,
    fetchDataSuccess,
    fetchDataFailure,
    updateLeadBrand
};
